import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { getPublishStyleKr } from '../utils/publishStyle';
import icModifyStyle from '../icons/ic-modify-style.svg';
import icModifyContent from '../icons/ic-modify.svg';
import icTrash from '../icons/ic-trash.svg';
import icBannerColumn from '../icons/ic-banner-column.svg';
import icBannerRow from '../icons/ic-banner-row.svg';
import icPopupColumn from '../icons/ic-popup-column.svg';
import icPopupRow from '../icons/ic-popup-row.svg';
import icDrawer from '../icons/ic-drawer.svg';
import { ReactComponent as NextIcon } from '../icons/ic-next.svg';
import { Link } from 'react-router-dom';

function MyCompleteContents(props) {
  const {
    title,
    completeYn,
    handleCodeCopy,
    thumbnail,
    openDeleteModal,
    handleModifyContents,
    handleManageContents,
    handleSetContents,
    style,
    isPublished,
    mobileYn,
    itemCount,
  } = props;

  const clickHandler = () => {
    if (mobileYn === 1) {
      handleSetContents();
    } else {
      handleModifyContents();
    }
  };

  const mapStyleToSVG = (style) => {
    switch (style) {
      case 'popup_v':
        return icPopupColumn;
      case 'popup_h':
        return icPopupRow;
      case 'banner_v':
        return icBannerColumn;
      case 'banner_h':
        return icBannerRow;
      case 'drawer':
        return icDrawer;
      default:
        return '';
    }
  };

  const svgFileName = mapStyleToSVG(style);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <div
          className="my-complete-contents-thumbnail"
          style={{
            width: 126,
            height: 71,
            borderRadius: 5,
            backgroundImage: `url(${thumbnail}) `,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        ></div>
        <div
          style={{
            width: 110,
            display: 'flex',
            flexDirection: 'column',
            marginLeft: 18,
          }}
        >
          <p style={{
            fontSize: 18,
            fontWeight: 700,
            color: 'black',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}>
            {title}
          </p>
          <p
            style={{
              fontSize: 12,
              fontWeight: 500,
              color: '#FFB600',
              marginTop: 4,
            }}
          >
            태그상품 {itemCount}개
          </p>
        </div>
        <div
          style={{
            width: 110,
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: isPublished ? 43 : 54,
              color: isPublished ? '#FFB600' : '#FF7A00',
              fontSize: 12,
              fontWeight: 600,
              border: isPublished ? '1px solid #FFB600' : '1px solid #FF7A00',
              borderRadius: 30,
              lineHeight: '26px',
            }}
          >
            {isPublished
              ? '완료'
              : '미완료'}
          </div>
          {!isPublished && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                marginBottom: 3,
              }}
            >
              <p
                style={{
                  color: 'black',
                  textAlign: 'center',
                  fontSize: 12,
                  fontWeight: 400,
                  textDecorationLine: 'underline',
                  cursor: 'copy',
                  lineHeight: '26px',
                }}
                onClick={handleCodeCopy}
              >
                코드 복사하기
              </p>
            </div>
          )}
        </div>
        <div style={{ width: 200, textAlign: 'center' }}>
          <div
            style={{
              border: '0.5px solid #B5B5B5',
              borderRadius: 8,
              height: 35,
              display: 'inline-flex',
              padding: '7px 10px',
              alignItems: 'center',
              gap: 6,
            }}
          >
            {svgFileName && <img src={svgFileName} />}
            <p style={{ color: 'black', fontSize: 12, fontWeight: 600 }}>
              {getPublishStyleKr(style)}
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, margin: '0 auto' }}>
          <div className="icon-button-container">
            <IconButton onClick={handleManageContents}>
              <img src={icModifyStyle} alt="디자인 수정하기" />
            </IconButton>
            <p
              className="icon-description"
              style={{
                fontSize: '10px',
                textAlign: 'center',
                marginTop: '2px',
                color: '#B5B5B5',
                whiteSpace: 'nowrap',
              }}
            >
              게시 관리
            </p>
          </div>
          <div className="icon-button-container">
            <IconButton onClick={handleModifyContents}>
              <img src={icModifyContent} alt="콘텐츠 수정하기" />
            </IconButton>
            <p
              className="icon-description"
              style={{
                fontSize: '10px',
                textAlign: 'center',
                marginTop: '2px',
                color: '#B5B5B5',
                whiteSpace: 'nowrap',
              }}
            >
              콘텐츠 수정
            </p>
          </div>
          <div className="icon-button-container">
            <IconButton onClick={openDeleteModal}>
              <img src={icTrash} alt="콘텐츠 삭제하기" />
            </IconButton>
            <p
              className="icon-description"
              style={{
                fontSize: '10px',
                textAlign: 'center',
                marginTop: '2px',
                color: '#B5B5B5',
                whiteSpace: 'nowrap',
              }}
            >
              게시 삭제
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyCompleteContents;

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 5px;
  border: 1px solid #b5b5b5;
  background: #fff;
  cursor: pointer;
`;

const ContentHandleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 14px;
  border-radius: 18.6px;
  background-color: ${(props) =>
    props.disabled
      ? '#B5B5B5'
      : props.completeYn === 1
        ? '#FF7A00'
        : '#FFB600'};
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  margin-right: 20px;
`;
